const Stats = ({ t }) => {
  const stats = [{ present: "75%" }, { absence: "3" }, { remaining: "2" }];
  return (
    <>
      <h3 className="font-semibold text-primary">{t("stats")}</h3>
      <section className="grid items-center grid-cols-1 gap-4 my-4 md:grid-cols-3">
        {stats.map((s, i) => {
          const [, value] = Object.entries(s)[0];
          const color = s.present ? "#D1A855" : s.absence ? "#902929" : "#3DC37C";
          const text = s.present
            ? "attendance%"
            : s.absence
            ? "absence"
            : "remainingSeats";

          return (
            <div
              key={i}
              className="flex flex-col items-center justify-center gap-3 p-4 border bg-sideBar border-primary rounded-xl"
            >
              <h4 className="text-xl font-bold" style={{ color }}>
                {value}
              </h4>
              <p className="text-sm font-semibold text-mainGray">{t(text)}</p>
            </div>
          );
        })}
      </section>
    </>
  );
};

export default Stats;
